import React, { useEffect, useState } from "react";
import AdvanceDataTable from "../UI/Table/AdvanceDataTable";
import { ADMIN_SMS_CAMPAIGN_DATA } from "../UI/Table/ColumnConst";
import ReactDatePicker from "react-datepicker";
import AdminLayout from "../UI/Layout/AdminLayout";
import Title from "../UI/Text/Title";
import Spining from "../UI/Spining/Spining";
import api from "../../axios/Axios";
import { userloginDetails } from "../Utils/AdminAuth";
import Select from "react-select";
import { HOST_URL, HOST_URL_DB2 } from "../Dashboard/api/Api";
import { faCalendarAlt, faDownload, faEye, faInfoCircle, faSearch, faSort } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FaSms } from "react-icons/fa";
import dayjs from "dayjs";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import Axios from "../../axios/Axios";

const SmsCampaignReport = () => {
  const lStorage = userloginDetails();
  const userId = lStorage?.user?.userId;
  const userToken = lStorage?.token;
  const adminType = lStorage.user.isAdmin;
  const subAdminPermission = lStorage?.permission?.per_value
  const [alert, setAlert] = useState({
    status: false,
    bgColor: "",
    errorMessage: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [campaign, setCampaign] = useState([]);
  const [fromdate, setFromdate] = useState(new Date());
  const [todate, setTodate] = useState(new Date());
  const [allusers, setAllusers] = useState([{ value: "", label: "All Users" }]);
  const [seleteduser, setSeletedusers] = useState("");
  const [totalCost, setTotalCost] = useState(null);
  const [totalFailed, setTotalFailed] = useState(null);
  const [totalDelivered, setTotalDeliverd] = useState(null);
  const [totalOptout, setTotalOptout] = useState(null);
  const [totalDnd, setTotalDnd] = useState(null);
  const [totalOther, setTotalOther] = useState(null);
  const [totalData, setTotalData] = useState(null);
  const [smsContent, setSmsContent] = useState('');
  const [sortOrder, setSortOrder] = useState("asc");
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const customStyles = {
    control: (provided) => ({
      ...provided,
      cursor: "pointer",
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    option: (style) => ({
      ...style,
      fontSize: "12px",
    }),
  };

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isMobile = windowWidth < 640;
  const isTablet = windowWidth >= 640 && windowWidth < 1024;

  useEffect(() => {
    usersList();
    campaigndata();
  }, []);

  // const usersList = () => {
  //   setIsLoading(true);
  //   fetch(
  //     `${HOST_URL}/admin_user_list.php?user_id=${userId}&method=retrieve_all_user&type=${adminType}&token=${userToken}`
  //   ).then((response) => {
  //     response.json().then((result) => {
  //       if (result.success === true) {
  //         let data = result.data.filter((items) => {
  //           if (items.status === 1) {
  //             return items;
  //           }
  //         });

  //         data.forEach((item) => {
  //           let newuserData = { value: item.user_id, label: item.user_name };
  //           setAllusers((prevState) => [...prevState, newuserData]);
  //         });
  //       } else {
  //         setAlert({
  //           status: true,
  //           bgColor: "danger",
  //           errorMessage: result.message,
  //         });
  //       }
  //     });
  //   });
  //   setIsLoading(false);
  // };

  const usersList = async () => {
    // setIsLoading(true);
    try {
      let paramData = {
        user_id: userId,
        method: "retrieve_all_user",
        type: adminType,
        token: userToken
      }

      const { data } = await Axios.post(`${HOST_URL}/admin_user_list.php`, paramData);

      if (data.success) {
        let filterData = data.data.map((x) => {
          return { value: x.id, label: x.email };
        });
        setAllusers(filterData);
      }
    } catch (error) {
      console.error("Error fetching users list:", error);
    } 
    
  };


  const currentDate = (currentDate) => {
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, "0");
    const day = String(currentDate.getDate()).padStart(2, "0");
    const formattedDate = `${year}-${month}-${day}`;
    return formattedDate;
  };

  const campaigndata = async () => {
    setIsLoading(true);
    let sDate = currentDate(fromdate);
    let eDate = currentDate(todate);

    if (adminType === "admin" || (adminType === "subadmin" && subAdminPermission.report.children.read)) {
      try {
        let params = {
          user_id: userId,
          method: "retrieve_admin",
          token: userToken,
          channel: "sms",
          from_date: sDate,
          to_date: eDate,
          seacrh_user_id: seleteduser,
        }

        const { data } = await Axios.post(`${HOST_URL_DB2}/bulk_campaign_sms.php`, params);

        if (data.success === true) {
          let totalCost = 0;
          let totaldelivered = 0;
          let totaldnd = 0;
          let totaloptout = 0;
          let totalfailed = 0;
          let contactCount = 0;
          let totalother = 0;

          data.data.forEach((item) => {
            let intValue = parseFloat(item.campaign_cost);
            totalCost += intValue;
            totaldelivered += item.delivered;
            totaloptout += item.optout;
            totaldnd += item.dnd;
            totalfailed += item.failed;
            contactCount += item.contact_count;
            totalother += item.other
          });

          setTotalData(contactCount);
          setTotalCost(totalCost);
          setTotalDeliverd(totaldelivered);
          setTotalFailed(totalfailed);
          setTotalOptout(totaloptout);
          setTotalDnd(totaldnd);
          setTotalOther(totalother)
          setCampaign(data.data);
          setIsLoading(false);
        } else {
          setCampaign([]);
          setIsLoading(false);
        }
      } catch (error) {
        console.log("Error fetching campaign data:", error);
        setIsLoading(false);
      }
    }
  };

  const userHandler = (e) => {
    setSeletedusers(e.value);
  };

  const fromdateHandler = (data) => {
    setFromdate(data);
  };
  const todateHandler = (data) => {
    setTodate(data);
  };

  const TemplateListDetails = (message) => {
    setSmsContent(message)
  }

  const handleSortClick = () => {
    const sorted = [...campaign].sort((a, b) =>
      sortOrder === "asc"
        ? a.contact_count - b.contact_count
        : b.contact_count - a.contact_count
    );

    setCampaign(sorted);
    setSortOrder(sortOrder === "asc" ? "desc" : "asc");
  };

  const handleSortdeliveredClick = () => {
    const sorted = [...campaign].sort((a, b) =>
      sortOrder === "asc"
        ? a.delivered - b.delivered
        : b.delivered - a.delivered
    );

    setCampaign(sorted);
    setSortOrder(sortOrder === "asc" ? "desc" : "asc");
  };

  const handleSortfailedClick = () => {
    const sorted = [...campaign].sort((a, b) =>
      sortOrder === "asc"
        ? a.failed - b.failed
        : b.failed - a.failed
    );

    setCampaign(sorted);
    setSortOrder(sortOrder === "asc" ? "desc" : "asc");
  };

  const handleSortoptoutClick = () => {
    const sorted = [...campaign].sort((a, b) =>
      sortOrder === "asc"
        ? a.optout - b.optout
        : b.optout - a.optout
    );

    setCampaign(sorted);
    setSortOrder(sortOrder === "asc" ? "desc" : "asc");
  };

  const handleSortdndClick = () => {
    const sorted = [...campaign].sort((a, b) =>
      sortOrder === "asc"
        ? a.dnd - b.dnd
        : b.dnd - a.dnd
    );

    setCampaign(sorted);
    setSortOrder(sortOrder === "asc" ? "desc" : "asc");
  };


  const handleSortotherClick = () => {
    const sorted = [...campaign].sort((a, b) =>
      sortOrder === "asc"
        ? a.other - b.other
        : b.other - a.other
    );

    setCampaign(sorted);
    setSortOrder(sortOrder === "asc" ? "desc" : "asc");
  };

  const sortByDate = () => {
    const sorted = [...campaign].sort((a, b) => {
      const dateA = new Date(a.camp_start_datetime);
      const dateB = new Date(b.camp_start_datetime);
      return sortOrder === 'asc' ? dateA - dateB : dateB - dateA;
    });

    setCampaign(sorted);
    setSortOrder(prev => (prev === 'asc' ? 'desc' : 'asc'));
  };

  const handleDownload = async (item) => {
    try {
      const formData = new FormData();
      formData.append("user_id", userId);
      formData.append("ret_user_id", item.user_id);
      formData.append("method", "download");
      formData.append("token", userToken);
      formData.append("channel", "sms");
      formData.append("campaign_id", item.id);
      formData.append("archive_status", item.archive_status);
      formData.append("camp_start_datetime", item.camp_start_datetime);
      formData.append("type", adminType);
      formData.append("username", item.user_name);

      const response = await Axios.post(
        `${HOST_URL_DB2}/bulk_campaign_sms.php`,
        formData,
        { responseType: "blob" }
      );

      const contentType = response.headers?.["content-type"] || response.data.type || "application/octet-stream";
      const contentDisposition = response.headers?.["content-disposition"] || "";

      let fileName = "";
      const fileNameMatch = contentDisposition.match(/filename\*?=(?:UTF-8'')?["']?([^"';\n]+)["']?/i);
      if (fileNameMatch && fileNameMatch[1]) {
        fileName = decodeURIComponent(fileNameMatch[1]);
      }

      const url = window.URL.createObjectURL(new Blob([response.data], { type: contentType }));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        fileName
      );
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download failed:", error);
    }
  };


  return (
    <div>
      <AdminLayout>
        <Title isButton={false}> Campaign Report </Title>

        {campaign.length > 0 &&
          <div className="row">
            <div className="col-xl-12 col-xxl-5 d-flex">
              <div className="w-100">
                <div className="row">
                  <div className="col-6 col-sm-4 col-md-2">
                    <div className="card">
                      <div className="card-body p-2">
                        <h5 className="card-title mb-0">Total Data</h5>
                        <h6 className="mt-0 mb-0">{totalData}</h6>
                      </div>
                    </div>
                  </div>
                  <div className="col-6 col-sm-4 col-md-2">
                    <div className="card">
                      <div className="card-body p-2">
                        <h5 className="card-title mb-0">Total Delivered</h5>
                        <h6 className="mt-0 mb-0">{totalDelivered}</h6>
                      </div>
                    </div>
                  </div>
                  <div className="col-6 col-sm-4 col-md-2">
                    <div className="card">
                      <div className="card-body p-2">
                        <h5 className="card-title mb-0">Total Failed</h5>
                        <h6 className="mt-0 mb-0">{totalFailed}</h6>
                      </div>
                    </div>
                  </div>
                  <div className="col-6 col-sm-4 col-md-2">
                    <div className="card">
                      <div className="card-body p-2">
                        <h5 className="card-title mb-0">Total Optout</h5>
                        <h6 className="mt-0 mb-0">{totalOptout}</h6>
                      </div>
                    </div>
                  </div>
                  <div className="col-6 col-sm-4 col-md-2">
                    <div className="card">
                      <div className="card-body p-2">
                        <h5 className="card-title mb-0">Total Dnd</h5>
                        <h6 className="mt-0 mb-0">{totalDnd}</h6>
                      </div>
                    </div>
                  </div>
                  <div className="col-6 col-sm-4 col-md-2">
                    <div className="card">
                      <div className="card-body p-2">
                        <h5 className="card-title mb-0">Total Other</h5>
                        <h6 className="mt-0 mb-0">{totalOther}</h6>
                      </div>
                    </div>
                  </div>
                  <div className="col-6 col-sm-4 col-md-2">
                    <div className="card">
                      <div className="card-body p-2 ">
                        <h5 className="card-title mb-0">Total Cost</h5>
                        <h6 className="mt-0 mb-0">
                          {parseFloat(totalCost).toFixed(2)}
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>}

        <div className="row">
          <div className="">
            {alert.status === true ? (
              <div className={alert.bgColor} role="alert">
                <button
                  type="button"
                  className="close"
                  data-dismiss="alert"
                  aria-label="Close"
                >
                  <span aria-hidden="true">×</span>
                </button>
                <div className="">{alert.errorMessage}</div>
              </div>
            ) : null}

            {isLoading && <Spining />}
            <div className="row justify-content-center">
              <div className="col-12 col-lg-12 col-xxl-12 d-flex">
                <div className="card flex-fill ">
                  <div className="card-header">

                    <div className="row">
                      <div className="col-12 col-md-3">
                        <label>Select User</label>
                        <div className="input-group drop-down-icons mb-2 mr-sm-2 table1">
                          <div className="input-group mb-2 mr-sm-2">
                            <Select
                              onChange={userHandler}
                              options={allusers}
                              isSearchable={true}
                              placeholder="All Users"
                              styles={customStyles}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-md-4">
                        <label>From:</label>
                        <div className="input-group mb-2 mr-sm-2">
                          <div className="input-group-text">
                            <FontAwesomeIcon icon={faCalendarAlt} />
                          </div>
                          <div>
                            <ReactDatePicker
                              className="form-control btn-block"
                              dateFormat="dd/MM/yyyy"
                              value={fromdate}
                              onChange={fromdateHandler}
                              selected={fromdate}
                              placeholderText="From Date"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-md-4">
                        <label>To:</label>
                        <div className="input-group mb-2 mr-sm-2">
                          <div className="input-group-text">
                            <FontAwesomeIcon icon={faCalendarAlt} />
                          </div>
                          <div>
                            <ReactDatePicker
                              className="form-control btn-block"
                              dateFormat="dd/MM/yyyy"
                              value={todate}
                              onChange={todateHandler}
                              selected={todate}
                              placeholderText="Date To"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-md-1">
                        <label></label>
                        <button
                          className="btn btn-success float-right"
                          onClick={campaigndata}
                        >
                          <FontAwesomeIcon className="fa-lg" icon={faSearch} />
                        </button>
                      </div>
                    </div>
                  </div>
                  {isLoading === true ? (
                    <Spining />
                  ) : (
                    <div className="col-md-12 mt-2">
                      {campaign < 1 && (
                        <div className="card d-flex justify-content-center align-items-center ">
                          <h6 className="mt-2">No Record Found</h6>
                        </div>
                      )}
                      {campaign?.map((item, i) => (
                        <div className="card" key={i}>
                          <div className="card-body">
                            <div className="d-flex flex-wrap justify-content-between" style={{ gap: "8px" }}>
                              <p>
                                {" "}
                                <FaSms className="text-primary mr-2" style={{ fontSize: '2em' }} />

                                <span>Campaign Name:{" "}</span>
                                <span style={{ fontWeight: "bold" }}>
                                  {item.campaign_name}{" "}
                                </span>{" "}
                              </p>
                              <p>
                                {item.status === 0 ? (
                                  <span className="badge bg-danger">
                                    Deleted
                                  </span>
                                ) : item.status === 1 ? (
                                  <span className="badge bg-info">
                                    Not Split
                                  </span>
                                ) : item.status === 2 ? (
                                  <span className="badge bg-warning">
                                    Schedule
                                  </span>
                                ) : item.status === 3 ? (
                                  <span className="badge bg-success">
                                    Completed
                                  </span>
                                ) : item.status === 4 ? (
                                  <span className="badge bg-danger">
                                    Schedule Deleted
                                  </span>
                                ) : null
                                }
                              </p>
                              <p>Campaign Date: {dayjs(item.camp_start_datetime).format("DD/MM/YYYY h:mm A")}<FontAwesomeIcon className="ml-2" onClick={sortByDate} style={{ cursor: "pointer" }} icon={faSort} /></p>
                            </div>
                            <hr className="m-0 mb-1"></hr>
                            <div className="d-flex flex-wrap summary-data text-center" style={{ gap: "8px" }}>
                              <div className="mb-1">
                                <span className="text-muted"> total </span> <FontAwesomeIcon onClick={handleSortClick} style={{ cursor: "pointer" }} icon={faSort} />{" "}
                                <br />
                                <span className="textvalue text-success">
                                  {" "}
                                  {item.contact_count}{" "}
                                </span>{" "}
                              </div>

                              <div className="mb-1">
                                <span className="text-muted">
                                  {" "}
                                  Delivered{" "}
                                </span><FontAwesomeIcon onClick={handleSortdeliveredClick} style={{ cursor: "pointer" }} icon={faSort} />{" "}
                                <br />
                                <span className="textvalue text-success">
                                  {" "}
                                  {item.delivered}{" "}
                                </span>{" "}
                              </div>

                              <div className="mb-1">
                                <span className="text-muted"> Failed </span><FontAwesomeIcon onClick={handleSortfailedClick} style={{ cursor: "pointer" }} icon={faSort} />
                                <br />{" "}
                                <span className="textvalue text-success">
                                  {" "}
                                  {item.failed}{" "}
                                </span>{" "}
                              </div>
                              <div className="mb-1">
                                <span className="text-muted"> Opt Out </span><FontAwesomeIcon onClick={handleSortoptoutClick} style={{ cursor: "pointer" }} icon={faSort} />
                                <br />{" "}
                                <span className="textvalue text-success">
                                  {" "}
                                  {item.optout}{" "}
                                </span>{" "}
                              </div>

                              <div className="mb-1">
                                <span className="text-muted"> DND </span><FontAwesomeIcon onClick={handleSortdndClick} style={{ cursor: "pointer" }} icon={faSort} />
                                <br />{" "}
                                <span className="textvalue text-success">
                                  {" "}
                                  {item.dnd || 0}{" "}
                                </span>{" "}
                              </div>

                              <div className="mb-1">
                                <span className="text-muted"> Other </span><FontAwesomeIcon onClick={handleSortotherClick} style={{ cursor: "pointer" }} icon={faSort} />
                                <br />{" "}
                                <span className="textvalue text-success">
                                  {" "}
                                  {item.other || 0}{" "}
                                </span>{" "}
                              </div>

                              <>
                                {item.archive_status === 1 ? null :
                                  <div className="mb-1">
                                    <span className="text-muted"> Report </span>
                                    <br />{" "}
                                    <Link
                                      to={`/admin/campaign/detailed-report/sms/${item.id}/${item.user_name}/${item.num_count}`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      <span className=" text-success">
                                        <FontAwesomeIcon className="mt-3" icon={faEye} />
                                      </span>
                                    </Link>
                                  </div>}

                                {/* <div className="mb-1">
                                      <span className="text-muted"> Other </span>
                                      <br />{" "}
                                      <span className="textvalue text-success">
                                        {" "}
                                        {item.other}{" "}
                                      </span>{" "}
                                    </div> */}

                                {(adminType === "admin" || (adminType === "subadmin" && subAdminPermission.report.children.download)) &&
                                  <div className="mb-1">
                                    <span className="text-muted"> Download </span>
                                    <br />
                                    <button
                                      className="text-success btn btn-link p-0"
                                      onClick={() => handleDownload(item)}
                                    >
                                      <FontAwesomeIcon className="mt-3" icon={faDownload} />
                                    </button>
                                  </div>}

                              </>
                            </div>
                            <div className="d-flex flex-wrap justify-content-between mt-1" style={{ gap: "4px" }}>
                              <div className="d-flex flex-wrap" style={{ gap: "4px" }}>
                                <small className="m-0, p-0">
                                  <span style={{ color: "black", fontSize: "10px" }}>Campaign ID:</span> <span style={{ color: "#4c0af5" }}>{item.id}</span><span style={{ color: "black" }}>/</span>
                                </small>
                                {/* {this.state.channel === "sms" ? <small>Template ID:  xxxxxxxx{item?.template_id?.substr(-4,4)}/</small> :
                                                <small>Template ID: {item?.template_id}/</small>} */}
                                {<small style={{ color: "black", fontSize: "10px" }}>Template ID: <span style={{ color: "#4c0af5" }}>{item?.template_id}</span><span className="no-style">/</span></small>}

                                {<small style={{ color: "black", fontSize: "10px" }}>Sender ID: <span style={{ color: "#4c0af5" }}>{item.sender_id}</span>/</small>}
                                {item.camp_type && <small style={{ color: "black", fontSize: "10px" }}>Campaign Type: <span style={{ color: "#4c0af5" }}>{item.camp_type === 1 ? <span>Normal</span> : item.camp_type === 3 ? <span>Dynamic</span> : null}</span>/</small>}
                                <small style={{ color: "black", fontSize: "10px" }}>Unicode: <span style={{ color: "#4c0af5" }}>{item.unicode === 1 ? <span>YES</span> : <span>NO</span>}</span>/</small>
                                {<small style={{ color: "black", fontSize: "10px" }}>User Name: <span style={{ color: "#4c0af5" }}>{item.user_name}</span>/</small>}
                                {<small style={{ color: "black", fontSize: "10px" }}>Submit From: <span style={{ color: "#4c0af5" }}>{item.submit_via}</span></small>}
                                <small
                                  style={{
                                    cursor: 'pointer',
                                    backgroundColor: smsContent ? '#f0f0f0' : 'transparent',
                                  }}
                                  className="ml-2"
                                  data-toggle="modal"
                                  data-target="#galleryPopup"
                                  onClick={() => TemplateListDetails(item?.text_message)}>
                                  <FontAwesomeIcon icon={faInfoCircle} /></small>
                              </div>
                              <small style={{ color: "black" }}>
                                Campaign Cost: {" "}
                                <span style={{ color: "#4c0af5" }}>{parseFloat(item.campaign_cost).toFixed(2)}</span>
                              </small>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                  <div
                    className="modal fade"
                    id="galleryPopup"
                    tabIndex="-1"
                    role="dialog"
                    aria-labelledby="galleryPopupLabel"
                    aria-hidden="true"
                  >
                    <div className="modal-dialog modal-md" role="document">
                      <div className="modal-content">
                        <div className="modal-header">
                          <h5 className="modal-title" id="galleryPopupLabel">
                            SMS Content
                          </h5>
                          <button
                            type="button"
                            className="close"
                            data-dismiss="modal"
                            aria-label="Close"
                          >
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>

                        <div className="modal-body">
                          <p>{smsContent}</p>
                        </div>

                        <div className="modal-footer">
                          <button
                            type="button"
                            data-dismiss="modal"
                            className="btn btn-info"
                          >
                            Close
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* <WhatsAppCampaignListPreview templateDetails={this.state.templateDetails} openTemplatePopup={this.state.openTemplatePopup} closePopup={this.closePopup} /> */}
                </div>
              </div>
            </div>

          </div>
        </div>
      </AdminLayout>
    </div>
  );
};

export default SmsCampaignReport;
